import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Clock, MapPin } from "lucide-react";
import ScrollToTopButton from "./ScrollToTopButton";
import { scrollToTop } from "../lib/utils";

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <Link
              to="/"
              onClick={() => scrollToTop()}
              className="flex items-center space-x-3 mb-6"
            >
              {/* <div className="w-10 h-10 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center">
                <div className="w-6 h-6 bg-gray-900 rounded-full flex items-center justify-center">
                  <div className="w-4 h-0.5 bg-white rounded-full"></div>
                  <div className="w-3 h-0.5 bg-amber-400 rounded-full ml-0.5"></div>
                </div>
              </div>
               */}
              <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center shadow-lg">
                <img
                  src={`${process.env.PUBLIC_URL}/pave-mark-logo.png`}
                  alt="Parking lot with markings"
                  className="w-12 h-12 object-cover text-center mx-auto"
                />
              </div>

              <div>
                <h3 className="text-lg font-bold">PaveMark</h3>
                <p className="text-gray-400 text-sm">Marquage au sol</p>
              </div>
            </Link>
            <p className="text-gray-300 text-sm leading-relaxed">
              Une entreprise québécoise à votre service, spécialisée dans le
              marquage au sol, la pose de scellant et la réparation de fissures
              d'asphalte.
            </p>
          </div>

          {/* Navigation Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Navigation</h4>
            <nav className="space-y-2">
              <Link
                to="/"
                onClick={() => scrollToTop()}
                className="block text-gray-300 hover:text-amber-400 transition-colors"
              >
                Accueil
              </Link>
              <Link
                to="/aboutus"
                onClick={() => scrollToTop()}
                className="block text-gray-300 hover:text-amber-400 transition-colors"
              >
                Qui sommes-nous
              </Link>
              <Link
                to="/fiber"
                onClick={() => scrollToTop()}
                className="block text-gray-300 hover:text-amber-400 transition-colors"
              >
                Fibre Urbaine
              </Link>
              <Link
                to="/contact"
                onClick={() => scrollToTop()}
                className="block text-gray-300 hover:text-amber-400 transition-colors"
              >
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-3">
                  <a
                    href={`tel:${atob("KDUxNCkgNzE4LTUxNDQ=")}`}
                    className="opacity-80 hover:opacity-100 transition-smooth"
                  >
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-amber-400 flex-shrink-0" />
                <span className="text-gray-300">
                    {atob("KDUxNCkgNzE4LTUxNDQ=")}
                </span>
              </div>
                  </a>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-amber-400 flex-shrink-0" />
                <span className="text-gray-300">
                  <a
                    href={`mailto:${atob("aW5mby5wYXZlbWFya0BnbWFpbC5jb20=")}`}
                    className="opacity-80 hover:opacity-100 transition-smooth"
                  >
                    {atob("aW5mby5wYXZlbWFya0BnbWFpbC5jb20=")}
                  </a>
                </span>
              </div>
              <div className="flex items-start space-x-3">
                <Clock className="h-5 w-5 text-amber-400 flex-shrink-0 mt-0.5" />
                <div className="text-gray-300 text-sm">
                  <div>Lun-Sam: 8:00 à 20:00</div>
                  <div>Dimanche: Fermé</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} PaveMark. Tous droits réservés.
            </p>
            <p className="text-gray-500 text-sm mt-2 md:mt-0">
              <a href="https://www.tiktok.com/@pavemark">TikTok</a>
            </p>
          </div>
        </div>
      </div>

      <ScrollToTopButton/>
    </footer>
  );
};

export default Footer;
